import React, { Component } from "react";
import { connect } from "react-redux";
import { quiz2DataWatch, quiz2DataUpdate } from "../../actions/quiz2Actions";

import produce from "immer";
import _ from "lodash";

class ViewData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: []
    };
  }

  componentDidMount() {
    const { data } = this.props || {};

    if (_.isEmpty(data)) {
      this.props.quiz2DataWatch();
    } else {
      this.setState(
        produce(draft => {
          draft.data = data;
        })
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { data: prevData } = prevProps;
    const { data: currData } = this.props;
    if (!_.isEqual(prevData, currData)) {
      this.setState(
        produce(draft => {
          draft.data = currData;
          return draft;
        })
      );
    }
  }

  handleChange = (idx, e) => {
    const { value, name } = e.target;
    switch (name) {
      case "no":
      case "answer":
        this.setState(
          produce(draft => {
            draft.data[idx][name] = Number.parseInt(value);
          })
        );
        break;
      case "question":
      case "ex1":
      case "ex2":
      case "ex3":
      case "explanation":
        this.setState(
          produce(draft => {
            draft.data[idx][name] = value;
          })
        );
        break;

      default:
        break;
    }
  };

  handleSubmit = (idx, e) => {
    e.preventDefault();
    console.log("submit", idx, this.state.data[idx]);

    this.props.quiz2DataUpdate(idx, this.state.data[idx]);
  };

  renderExamples = (d, index) => {
    const examples = ["ex1", "ex2", "ex3"];
    const idx = index;
    return examples.map((ex, innerIdx) => (
      <div
        key={innerIdx}
        className="col-12 d-flex justify-content-between align-items-center my-1"
      >
        <label className="px-3">{ex}</label>
        <input
          rows="1"
          className="d-block w-100"
          type="text"
          name={ex}
          value={d[ex]}
          onChange={e => this.handleChange(idx, e)}
        />
      </div>
    ));
  };

  renderRow = data => {
    const { data: prevData } = this.props;

    return data.map((d, idx) => (
      <div key={idx} className="row my-5">
        <div className="col-12">
          <form onSubmit={e => this.handleSubmit(idx, e)} className="row">
            {/* NO */}
            <div className="col-1 d-flex justify-content-between align-items-center my-1">
              <input
                className="d-block w-100"
                type="text"
                name="no"
                value={d.no}
                onChange={e => this.handleChange(idx, e)}
                readOnly
              />
            </div>

            {/* QUESTION && EXAMPLES && EXPLANATION CONTAINER */}
            <div className="col-9">
              <div className="row">
                {/* QUESTION */}
                <div className="col-12 d-flex justify-content-between align-items-center my-1">
                  <input
                    className="d-block w-100"
                    type="text"
                    name="question"
                    value={d.question}
                    onChange={e => this.handleChange(idx, e)}
                  />
                </div>

                {/* EXAMPLES */}
                {this.renderExamples(d, idx)}

                {/* EXPLANATION */}
                <div className="col-12 d-flex justify-content-between align-items-center my-1">
                  <textarea
                    rows="2"
                    className="d-block w-100"
                    type="text"
                    name="explanation"
                    value={d.explanation}
                    onChange={e => this.handleChange(idx, e)}
                  />
                </div>
              </div>
            </div>

            {/* ANSWER */}
            <div className="col-1 d-flex justify-content-between align-items-center my-1">
              <select
                className="d-block w-100"
                type="text"
                name="answer"
                value={d.answer}
                onChange={e => this.handleChange(idx, e)}
              >
                <option value="1" style={{ backgroundColor: "white" }}>
                  ex1
                </option>
                <option value="2" style={{ backgroundColor: "white" }}>
                  ex2
                </option>
                <option value="3" style={{ backgroundColor: "white" }}>
                  ex3
                </option>
              </select>
            </div>

            {/* SUBMIT */}
            <div className="col-1 d-flex justify-content-between align-items-center my-1">
              <button
                type="submit"
                className="d-block w-100 btn btn-danger btn-block"
                style={{ height: "100%" }}
                disabled={_.isEqual(data[idx], prevData[idx])}
              >
                수정
              </button>
            </div>
          </form>
        </div>
      </div>
    ));
  };

  render() {
    const { data } = this.state;
    return <div>{this.renderRow(data)}</div>;
  }
}

const mapStateToProps = state => ({
  data: state.quiz2.data
});

export default connect(
  mapStateToProps,
  { quiz2DataWatch, quiz2DataUpdate }
)(ViewData);
